import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FormSearchFilter from "../../components/common/form-search-filter/FormSearchFilter";
import { useLocation, useNavigate } from "react-router-dom";
import MuiTableWrapper from "../../components/common/mui-table-wrapper/MuiTableWrapper";
import { toast } from "react-toastify";
import FallbackGeneratedFormMessage from "../../components/common/fallback-form-message/FallbackGeneratedFormMessage";
import { del, get, patch } from "../../common/network";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import AddNewCategory from "../../components/common/modal-preview/AddNewCategory";
import useSweetAlert from "../../components/common/alert/useSweetAlert";

const CategoryForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const categoryId = location.state?.categoryId;
    const paramsCategoryName = location.state?.categoryName;
    const [forms, setForms] = useState([]);
    const [categoryName, setCategoryName] = useState(paramsCategoryName);
    const [editCategoryName, setEditCategoryName] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [rowsSelection, setRowsSelection] = useState([]);
    const [addNewModalOpen, setAddNewModalOpen] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [formTypeValue, setFormTypeValue] = useState("");
    const sweetAlert = useSweetAlert();

    useEffect(() => {
        fetchFormsByCategoryId();
    }, [categoryId]);


    const handleUpdateCategoryName = async () => {
        try {
            const response = await patch(`docgen/categories/${categoryId}`, { name: categoryName }, {}, false);
            if (response?.status === 200) {
                setCategoryName(response?.data?.name);
                setEditCategoryName(false);
                navigate(`/docgen/categories/form`, { replace: true, state: { categoryId, categoryName: response?.data?.name } });
            }
        }
        catch (err) {
        }
    }

    const handleSearch = (value) => {
        const columnName = value?.value || ""; // Name of the column
        const searchValue = value?.searchedText || "";
        const dropdownValue = value?.dropdownValue || ""; // value selected in the dropdown field
        setSearchText(searchValue);
        setFilterText(columnName);
        setFormTypeValue(dropdownValue);

        if (columnName === "updated_at") {
            setDateValue(value);
        }
    };

    const fetchFormsByCategoryId = async () => {
        setIsFetching(true)
        try {
            const response = await get(`docgen/categories/${categoryId}`, {}, false);
            if (response?.status === 200) {
                setCategoryName(response?.data?.name);
                let formMap = response?.data?.categoryFormMap || [];
                formMap = formMap
                    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
                    .map(item => ({
                        ...item?.docgen_forms,
                    }));
                setForms(formMap);
                setSelectedRows([]);
                setRowsSelection([]);
            }
        }
        catch (err) {
        }
        finally {
            setIsFetching(false)
        }
    }

    const handleMultipleDelete = () => {
        sweetAlert({
            title: "Are you sure?",
            text: `Are you sure you want to delete the selected form(s)?`,
            icon: "warning",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed == true) {
                const formIds = selectedRows?.map((row) => row.id);
                handleDeleteForm(formIds);
            }
        });
    }

    const confirmFormDeletion = async (form) => {
        sweetAlert({
            title: "Please Confirm",
            text: `Would you like to delete '${form?.form_name}'?`,
            icon: "warning",
            cancelButtonText: "No",
            confirmButtonText: "Yes",
        }).then((result) => {
            if (result.isConfirmed == true) {
                handleDeleteForm([form?.id]);
            }
        });
    }

    const handleDeleteForm = async (formIds) => {
        try {
            const response = await del(`docgen/categories/${categoryId}/forms`, {
                formIds
            }, {}, false);
            if (response?.status === 200) {
                toast.success("Deleted Successfully");
                fetchFormsByCategoryId();
            }
        }
        catch (err) {
        }
    }

    const handleModalClose = () => {
        setAddNewModalOpen(false)
    }

    const columns = [
        {
            field: "form_name",
            header: "Forms Name",
            render: (value, row) => {
                return (
                    <div
                        style={{ textDecoration: "underline", cursor: "pointer", paddingTop: "0.5%", paddingBottom: "0.5%" }}
                        onClick={() => {
                            window.open(`/docgen/form/details?id=${row.id}`);
                        }}>
                        {value}
                    </div>
                );
            }
        },
        {
            field: "form_code",
            header: "Form Code",
        },
        {
            field: "form_type",
            header: "Type",
        },
        {
            field: "country",
            header: "Country",
        },
        {
            field: "id",
            header: "Actions",
            filter: false,
            sort: false,
            render: (value, row) => {
                return (
                    <DeleteOutlineIcon
                        onClick={() => confirmFormDeletion(row)}
                        style={{ cursor: "pointer" }}
                    />
                );
            }
        }
    ];
    return (
        <div className="category">
            <div className="category-header m-0">
                <div style={{ display: "flex" }}>
                    {editCategoryName ?
                        <>
                            <TextField
                                label="Category Name"
                                id="category-name"
                                variant="outlined"
                                size="small"
                                sx={{ m: 1, width: '25ch' }}
                                value={categoryName}
                                onChange={(e) => setCategoryName(e.target.value)}
                            />
                            <Button size="small" variant="text" onClick={handleUpdateCategoryName}>Save</Button>
                        </>
                        :
                        <>
                            <h4 className="category-title">
                                {categoryName}
                            </h4>
                            <EditOutlinedIcon
                                style={{ marginLeft: "5px", cursor: "pointer" }}
                                onClick={() => setEditCategoryName(true)}
                            />
                        </>
                    }
                </div>
            </div>
            <div className="category-header">
                <div>
                    <FormSearchFilter
                        options={[
                            { value: "", label: "All" },
                            { value: "form_name", label: "Form Name" },
                            { value: "form_code", label: "Form Code" },
                            { value: "form_type", label: "Type" },
                            { value: "country", label: "Country" },
                        ]}
                        defaultOption={{ value: "", label: "Select an option" }}
                        dateFiltersOptionsValueArray={[]}
                        dropdownArray={["form_type"]}
                        dropdownOptions={{
                            form_type: [
                                {
                                    value: "standard",
                                    label: "Standard"
                                },
                                {
                                    value: "custom",
                                    label: "Custom"
                                }
                            ],
                        }}
                        onSearch={(values) => handleSearch(values)}
                    />
                </div>
                <div className="category-controls">
                    <section className="top-actions-section">
                        <div className="buttons-group">
                            <ul>
                                {
                                    Array.isArray(selectedRows) && selectedRows?.length > 0 &&
                                    <li style={{ marginRight: "0.5rem" }}>
                                        <Button type="button" onClick={handleMultipleDelete}>
                                            <div className="icon-area">
                                                <DeleteOutlineIcon />
                                            </div>
                                            <p className="text-area">Delete</p>
                                        </Button>
                                    </li>
                                }
                            </ul>
                        </div>
                    </section>
                    <Button
                        variant="contained"
                        onClick={() => setAddNewModalOpen(true)}
                        sx={{ textTransform: 'none' }}
                    >
                        Add Forms
                    </Button>
                </div>
            </div>

            <MuiTableWrapper
                columns={columns}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                emptyBody={<FallbackGeneratedFormMessage />}
                colgroup={[
                    { width: "65%" },
                    { width: "15%" },
                    { width: "10%" },
                    { width: "5%" }
                ]}
                isFetching={isFetching}
                data={forms}
                searchValue={searchText}
                filterColumn={filterText}
                formTypeValue={formTypeValue}
                rowsSelection={rowsSelection}
                setRowsSelection={setRowsSelection}
            />
            <AddNewCategory
                openModal={addNewModalOpen}
                onClose={handleModalClose}
                formType={"Forms"}
                callback={fetchFormsByCategoryId}
                categoryId={categoryId}
                fetchedCategoryName={categoryName}
            />

        </div>
    )
}

export default CategoryForm;